import { Res } from '@cbo/shared-library';
import Box from '@mui/material/Box';
import DataGrid, { BaseDataGridProps } from '../../../components/DataGrid/DataGrid';

export interface CompanyLinkRowData extends Res.Firebase.Link {
  [key: string]: unknown;
  viewers: string;
}

interface CompanyLinksDataGridProps extends BaseDataGridProps {
  isLoading: boolean | null;
}

function CompanyLinksDataGrid(props: CompanyLinksDataGridProps) {
  const { isLoading } = props;
  return (
    <Box data-testid='company-links-datagrid'>
      <DataGrid {...props} loading={isLoading ?? true} />
    </Box>
  );
}

export default CompanyLinksDataGrid;
